module.exports = window.dnn.Sites.CommonReducers;